import Head from 'next/head'
import Link from 'next/link'
import path from 'path'
import { promises as fs } from 'fs'
import Header from '../src/local/Header'
import ErrorBoundary from '../src/local/ErrorBoundary'
import { HolmiAppFullLogo } from '../src/local/HolmiAppLogo'
import styles from '../styles/Galeria.module.css'

interface GalleryImage {
  filename: string
  title: string
  src: string
}

interface GaleriaProps {
  images: GalleryImage[]
}

function formatTitle(filename: string) {
  return filename.replace(/\.[^.]+$/, '')
}

export default function Galeria({ images }: GaleriaProps) {
  const currentYear = new Date().getFullYear()

  return (
    <ErrorBoundary>
      <div className={styles.site}>
        <Head>
          <title>HolmiApp – Galéria</title>
        </Head>

        <Header />

        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>Galéria</h1>
        </div>

        {images.length === 0 ? (
          <div className={styles.empty}>Jelenleg nincs kép a galériában.</div>
        ) : (
          <div className={styles.grid}>
            {images.map((image) => (
              <article className={styles.card} key={image.filename}>
                <div className={styles.cardImage}>
                  <img src={image.src} alt={image.title} className={styles.image} />
                </div>
                <div className={styles.cardBody}>
                  <h2 className={styles.cardTitle}>{image.title}</h2>
                </div>
              </article>
            ))}
          </div>
        )}

        <footer className={styles.footer}>
          <HolmiAppFullLogo height={28} className={styles.footerLogoImg} />
          <div className={styles.footerLinks}>
			<Link href="/">Főoldal</Link>
            <Link href="/Bemutato">Bemutató</Link>
            <Link href="/Telepulesek">Települések</Link>
            <Link href="/Onkormanyzat">Önkormányzat</Link>
            <Link href="/Galeria">Galéria</Link>
          </div>
          <span className={styles.footerCopy}>© {currentYear} HolmiApp. Minden jog fenntartva.</span>
        </footer>
      </div>
    </ErrorBoundary>
  )
}

export async function getStaticProps() {
  const galleryPath = path.join(process.cwd(), 'public', 'gallery')
  let filenames: string[] = []

  try {
    filenames = await fs.readdir(galleryPath)
  } catch {
    filenames = []
  }

  const images = filenames
    .filter((file) => /\.(png|jpe?g|webp|avif)$/i.test(file))
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
    .map((filename) => ({
      filename,
      title: formatTitle(filename),
      src: `/gallery/${filename}`,
    }))

  return {
    props: {
      images,
    },
  }
}
